import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';

import { ConfigService } from '../config/config.service';
export class SellerConnectService {
    title = 'Seller Connect Service';
private config: any;
private sellerConnectUrl = 'https://connect.stripe.com/oauth/authorize';
private getAuthorizationTokenUrl = '';
/**
 * @param {?} http
 * @param {?} configService
 */
constructor(
private http: Http,
private configService: ConfigService) {
        this.configService.getConfig((configuration: any) => {
            this.config = configuration;
            this.getAuthorizationTokenUrl = this.config.baseUrl + '/purchases/client-auth-token';
        });
    }
/**
 * @return {?}
 */
connectSeller(): Observable<any> {
        const /** @type {?} */ url = this.sellerConnectUrl + '?response_type=code&client_id=' + this.config.stripe_client_id + '&scope=read_write';
        try {
            return this.http.get(url).map(res => res.json());
        }
        catch ( /** @type {?} */err) {
            window.alert('Error in seller-connect.service.ts: connectSeller: err = ' + err);
        }
    };
/**
 * @param {?} authorizationCode
 * @return {?}
 */
getConnectToken(authorizationCode: string): Observable<any> {
        const /** @type {?} */ url = this.getAuthorizationTokenUrl;

        try {
            const /** @type {?} */ body = JSON.stringify({ authcode: authorizationCode })
            const /** @type {?} */ headers = new Headers({ 'Content-Type': 'application/json' })
            const /** @type {?} */ options = new RequestOptions({ 'headers': headers })

            // return this.http.post(url, body, options)
            //     .map((res: Response) => res.json())
            //     .catch((error: any) => Observable.throw(error.json().error || 'Server error'));

            console.log(url);

            return this.http.post(url, body, {headers: headers})
                .map((res: Response) => res.json())
                .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
        }
        catch ( /** @type {?} */err) {
            window.alert('Error in seller-connect.service.ts: connectSeller: err = ' + err);
        }
    };
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Http, },
{type: ConfigService, },
];
}

function SellerConnectService_tsickle_Closure_declarations() {
/** @type {?} */
SellerConnectService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SellerConnectService.ctorParameters;
/** @type {?} */
SellerConnectService.prototype.title;
/** @type {?} */
SellerConnectService.prototype.config;
/** @type {?} */
SellerConnectService.prototype.sellerConnectUrl;
/** @type {?} */
SellerConnectService.prototype.getAuthorizationTokenUrl;
/** @type {?} */
SellerConnectService.prototype.http;
/** @type {?} */
SellerConnectService.prototype.configService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
